module.exports = __webpack_public_path__ + "static/img/rank-1.9c2fb80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rank-1.png
// module id = QslB
// module chunks = 1